<!-- Hero Section -->
    <div class="hero">
        <div class="hero-content container">
            <h1>Boost Your 11+ Preparation with Our Weekly <br> Topic Tests</h1>
            <p>Carefully designed weekly tests covering Maths, English, Creative Writing, Verbal Reasoning(VR) & Non Verbal Reasoning(NVR) — helping students master the syllabus from October to February.
                Conducted across multiple UK centres including Harrow, Ilford, Chelmsford, Basildon, Southend, Amersham, Milton Keynes and Bexley, covering CSSE, FSCE (CCHS) and GL exam formats.
            </p>
            <a [routerLink]="['/11plus-mock-test']" [queryParams]="{ category: 19, scroll: 'calendar-section' }" class="cta-button">Book Topic Test</a>

             <a (click)="downloadCalendar()" class="cta-button ft-btn">Download Schedule</a>
        </div>
    </div>

    <!-- Section 1: Why Topic Tests -->
    <section id="why-topic-tests">
        <div class="container">
            <h2 class="section-title">Step-by-Step Preparation for 11+ Success</h2>
            <p class="section-subtitle">Our weekly Topic Tests are crafted to help students gradually cover the entire 11+ syllabus</p>
            
            <div class="topics-grid">
                <div class="topic-card">
                    <div class="topic-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M3 3l18 18M3 21l6-6m6-6l6-6M3 3h18v18"/>
                            <path d="M3 12h18M12 3v18"/>
                        </svg>
                    </div>
                    <h3>Maths</h3>
                    <p>Problem-solving & reasoning skills development</p>
                </div>
                <div class="topic-card">
                    <div class="topic-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                            <path d="M10 6h6M10 10h6M10 14h6"/>
                        </svg>
                    </div>
                    <h3>English</h3>
                    <p>Comprehension & grammar mastery</p>
                </div>
                <div class="topic-card">
                    <div class="topic-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M17 3a2.83 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/>
                        </svg>
                    </div>
                    <h3>Creative Writing</h3>
                    <p>Imagination & expression enhancement</p>
                </div>
                <div class="topic-card">
                    <div class="topic-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <rect x="3" y="3" width="7" height="7"/>
                            <rect x="14" y="3" width="7" height="7"/>
                            <rect x="14" y="14" width="7" height="7"/>
                            <rect x="3" y="14" width="7" height="7"/>
                        </svg>
                    </div>
                    <h3>VR & NVR</h3>
                    <p>Verbal & Non-Verbal reasoning practice</p>
                </div>
            </div>

            <p style="text-align: center; margin-top: 40px; font-size: 1.5rem; color: #555;">
                These tests act as a warm-up before the full Mock Test series (March–September), allowing students to identify weak spots and build consistent confidence.
            </p>
        </div>
    </section>

    <!-- Section 2: Proven Results -->
    <section id="proven-results">
        <div class="container">
            <h2 class="section-title">Trusted by Parents, Loved by Students</h2>
            <p class="section-subtitle">Historically, our Topic Tests have been highly recommended by alumni parents, with many students going on to achieve top results in 11+ exams.</p>
            
            <div class="results-content">
                <div class="result-stat">
                    <div class="stat-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <circle cx="12" cy="12" r="10"/>
                            <circle cx="12" cy="12" r="6"/>
                            <circle cx="12" cy="12" r="2"/>
                        </svg>
                    </div>
                    <h3>Targeted</h3>
                    <p>Practice</p>
                </div>
                <div class="result-stat">
                    <div class="stat-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M3 3v18h18"/>
                            <path d="M18 17V9l-5 5-3-3-4 4"/>
                        </svg>
                    </div>
                    <h3>Regular</h3>
                    <p>Progress Tracking</p>
                </div>
                <div class="result-stat">
                    <div class="stat-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                            <path d="M6 2l3 3-3 3M18 16l-3 3 3 3"/>
                        </svg>
                    </div>
                    <h3>Confidence</h3>
                    <p>Building Week by Week</p>
                </div>
            </div>

            <div style="text-align: center; margin-top: 40px;">
                <a [routerLink]="['/11plus-mock-test']" [queryParams]="{ category: 19, scroll: 'calendar-section' }" class="cta-button">Book Topic Test</a>
            </div>
        </div>
    </section>

    <!-- Section 3: Test Schedule -->
    <section id="test-schedule">
        <div class="container">
            <h2 class="section-title">Weekly Tests | October – February</h2>
            
            <div class="schedule-timeline">
                <div class="timeline-item">
                    <div class="timeline-icon">📅</div>
                    <div class="timeline-content">
                        <h4>Weekly Tests</h4>
                        <p>Tests are conducted weekly, covering different topics systematically</p>
                    </div>
                </div>
                <div class="timeline-item">
                    <div class="timeline-icon">🏫</div>
                    <div class="timeline-content">
                        <h4>Flexible Schedule</h4>
                        <p>Designed to fit smoothly into school and home schedules</p>
                    </div>
                </div>
                <div class="timeline-item">
                    <div class="timeline-icon">✅</div>
                    <div class="timeline-content">
                        <h4>Consistent Preparation</h4>
                        <p>Helps students stay consistent and avoid last-minute stress</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Section 4: How Topic Tests Help -->
<section id="how-it-helps">
  <div class="container">
    <h2 class="section-title">Your 11+ Preparation, Organized</h2>
    <div class="benefits-grid">
      <div class="benefit-card">
        <div class="benefit-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <path d="m21 21-4.35-4.35"></path>
          </svg>
        </div>
        <h3>Identify Weak Areas</h3>
        <p>Focused questions highlight where improvement is needed</p>
      </div>
      <div class="benefit-card">
        <div class="benefit-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 3v18h18"></path>
            <path d="m19 9-5 5-4-4-3 3"></path>
          </svg>
        </div>
        <h3>Result Analysis Report(RAR)</h3>
        <p>Track Progress Understand strengths and gaps over time with Result Analysis Report</p>
      </div>
      <div class="benefit-card">
        <div class="benefit-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
            <path d="M6 12v5c3 3 9 3 12 0v-5"></path>
          </svg>
        </div>
        <h3>Confidence Boost</h3>
        <p>Step-by-step readiness for full Mock Tests</p>
      </div>
      <div class="benefit-card">
        <div class="benefit-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
          </svg>
        </div>
        <h3>Syllabus Coverage</h3>
        <p>Every topic in Maths, English, Creative Writing, VR & NVR</p>
      </div>
    </div>
  </div>
</section>

    <!-- Section 5: How to Register -->
    <section id="register">
        <div class="container">
            <h2 class="section-title">Get Started in 3 Easy Steps</h2>
            
            <div class="steps-container">
                <div class="step">
                    <div class="step-number">1</div>
                    <h3>Sign Up</h3>
                    <p>Quick registration online</p>
                </div>
                <div class="step">
                    <div class="step-number">2</div>
                    <h3>Choose Your Plan</h3>
                    <p>Weekly tests for Oct–Feb</p>
                </div>
                <div class="step">
                    <div class="step-number">3</div>
                    <h3>Start Practicing</h3>
                    <p>Get immediate access to topic-specific tests</p>
                </div>
            </div>

            <div style="text-align: center; margin-top: 50px;">
                <a [routerLink]="['/11plus-mock-test']" [queryParams]="{ category: 19, scroll: 'calendar-section' }" class="cta-button">Register for Topic Tests Now</a>
            </div>
        </div>
    </section>


      <!-- Weekly plan -->

<div class="weekly-session-container">
  <div class="header">
    <h1>Weekly Session Plan</h1>
  </div>
  
  <div class="sessions-grid">
    <div class="session-card" *ngFor="let week of weeks">
      <div class="week-title">Week {{ week.weekNumber }}</div>
      <div class="subject-list">
        <div class="subject-item" *ngFor="let subject of week.subjects">
          {{ subject }}
        </div>
      </div>
    </div>
  </div>
</div>


    <!-- Section 6: Testimonials -->
    <section id="testimonials">
        <div class="container">
            <h2 class="section-title">What Parents Say</h2>
            
            <div class="testimonials-grid">
                <div class="testimonial-card">
                    <p class="testimonial-text">"These weekly tests helped my child gradually master every topic. By the time the full mocks started, she was confident and ready."</p>
                    <p class="testimonial-author">— Alumni Parent</p>
                </div>
                <div class="testimonial-card">
                    <p class="testimonial-text">"The Topic Tests are a game-changer. They highlight weak areas and give students a structured routine."</p>
                    <p class="testimonial-author">— Alumni Parent</p>
                </div>
                <div class="testimonial-card">
                    <p class="testimonial-text">"We saw consistent improvement week after week. The systematic approach made all the difference in our child's preparation."</p>
                    <p class="testimonial-author">— Alumni Parent</p>
                </div>
            </div>
        </div>
    </section>



    <!-- Section 7: FAQ -->
    <section id="faq">
        <div class="container">
            <h2 class="section-title">Have Questions?</h2>
            
            <div class="faq-container">
                <div class="faq-item">
                    <p class="faq-question">Q: What age group are these tests for?</p>
                    <p class="faq-answer">A: Designed for students preparing for 11+ exams (typically Year 5/6).</p>
                </div>
                <div class="faq-item">
                    <p class="faq-question">Q: Are the tests online or offline?</p>
                    <p class="faq-answer">A: Both options are available, depending on location and preference.</p>
                </div>
                <div class="faq-item">
                    <p class="faq-question">Q: How long does each test take?</p>
                    <p class="faq-answer">A: Approximately 30–45 minutes per weekly test.</p>
                </div>
            </div>
        </div>
    </section>

    <!-- Footer CTA -->
    <div class="footer-cta">
        <div class="container">
            <h2>Start Your 11+ Journey Today</h2>
            <a [routerLink]="['/11plus-mock-test']" [queryParams]="{ category: 19, scroll: 'calendar-section' }" class="cta-button ft-btn">Register for Topic Tests</a>
        </div>
    </div>